import type { Candle } from "../types";

export interface PriceRange { min: number; max: number }

export function niceStep(range: number, ticks: number): number {
  const raw = range / ticks;
  const mag = Math.pow(10, Math.floor(Math.log10(raw)));
  const norm = raw / mag;
  const step = norm < 1.5 ? 1 : norm < 3 ? 2 : norm < 7 ? 5 : 10;
  return step * mag;
}

// Vertical scale: auto-fit to visible candles unless the user dragged the axis (override).
export class PriceScale {
  override: PriceRange | null = null;

  compute(candles: Candle[], start: number, end: number): PriceRange | null {
    if (this.override) return this.override;
    let min = Infinity, max = -Infinity;
    for (let i = Math.max(0, start); i <= end; i++) {
      const c = candles[i];
      if (!c) continue;
      if (c.low < min) min = c.low;
      if (c.high > max) max = c.high;
    }
    if (!isFinite(min)) return null;
    const pad = (max - min) * 0.12 || max * 0.001;
    return { min: min - pad, max: max + pad };
  }

  scaleBy(factor: number, base: PriceRange) {
    const mid = (base.min + base.max) / 2;
    const half = ((base.max - base.min) / 2) * factor;
    this.override = { min: mid - half, max: mid + half };
  }
}
